import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  align-items: ${(props) => props.align || "center"};
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
`;

const Label = styled.div`
  text-align: left;
  flex: 1;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Children = styled.div`
  flex: 2;
`;

const SC = {
  Container,
  Label,
  Children,
};

export default SC;
